import { render } from "./GrapesListPage.vue?vue&type=template&id=c6b31b6e&scoped=true"
import script from "./GrapesListPage.vue?vue&type=script&lang=js"
export * from "./GrapesListPage.vue?vue&type=script&lang=js"

import "./GrapesListPage.vue?vue&type=style&index=0&id=c6b31b6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c6b31b6e"

export default script